import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { MathRecipeItemProps } from '~/landing/consts/Landing.consts'
import SVGImage from '~/components/Image/SVGImage'

export default function MathRecipeItemMobile({
  props,
  isLastItem,
}: {
  props: MathRecipeItemProps
  isLastItem: boolean
}): React.ReactElement {
  const { t } = useTranslation('landing')
  const { step, icon, title, description } = props

  const pointUp = step % 2 === 1
  return (
    <div className="flex relative justify-center items-center w-76 h-40">
      <SVGImage
        className="w-full h-full absolute -ml-24 mt-4"
        height={12}
        imageClassName="object-contain absolute z-1"
        srcKey="landing/pointerHook.svg"
      />
      <div className="flex relative bg-gradient-eggplant-violet w-full h-full border border-blue-logo rounded z-10">
        <div className="flex flex-col gap-4 items-center justify-center w-2/5 pl-2 pr-4">
          <div
            className={`rounded-full px-4 py-1 ${
              isLastItem ? 'bg-bronze text-white' : pointUp ? 'bg-white text-purple' : 'bg-purple text-white'
            }`}
          >
            <p className="text-xs 2xl:text-5 font-bold uppercase">{`${t('mathRecipe.step')} ${step}`}</p>
          </div>
          <div className="flex items-center justify-center w-18 h-18">
            <ResponsiveImage fetchPriority="high" fit="contain" height={150} srcKey={icon} width={150} />
          </div>
        </div>
        <div className="flex w-3/5 py-2 -ml-2">
          <div className="flex flex-col gap-1.5 w-full justify-center items-start text-start">
            <p className="text-5 font-bold leading-5.5">{t(title)}</p>
            <p className="text-xs leading-4">{t(description)}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
